"use client";

import { ModalContent } from "@decibeltrade/web-core/modal";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

import { Skeleton } from "@/components/skeleton";

import { useLazyModalClose } from "../lazy-modal-close";
import { ModalCloseButton } from "../modal-close-button";
import { modalContentStyles } from "./modal-styles";

/**
 * Stands in for the deposit modal while its chunk downloads. Shaped like the form it replaces —
 * header, asset select, source, amount, submit — so the shell does not jump when it arrives.
 */
export function DepositModalSkeleton() {
  const close = useLazyModalClose();

  return (
    <ModalContent className={modalContentStyles()}>
      <div className={stack({ gap: "12", w: "full" })}>
        <ModalCloseButton close={close} />
        <Skeleton className={css({ h: "24", w: "[96px]", mx: "auto", borderRadius: "200" })} />
        <Skeleton className={css({ h: "32", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "56", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "56", w: "full", borderRadius: "300" })} />
        <Skeleton className={css({ h: "48", w: "full", borderRadius: "300" })} />
      </div>
    </ModalContent>
  );
}
